import auth from 'api/auth';
import { functionCollectBrowserData } from 'helpers/browserData/functionCollectBrowserData';
import { resetTokensAndSendToLogin, saveTokensAfterAuthentication } from 'helpers/cookies';
import { validateActivateLink } from 'helpers/validateActivateLinks';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useSearchParams } from 'react-router';
import { useAppSelector } from 'store/hook';

const Confirm = () => {
  const { messageApi } = useAppSelector((store) => store.windowState);  
  
  const navigate = useNavigate();
  const { user_id } = useParams();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const link_id = searchParams.get('link_id') || '';
  const room_id = searchParams.get('room_id') || undefined;
  useEffect(() => {
    const controller = new AbortController();
    onAccept(controller.signal);
    return () => controller.abort();
  }, [user_id]);

  useEffect(() => {    
    validateActivateLink(link_id, t, navigate, undefined, undefined, messageApi);
  },[])

  const onAccept = async (signal: AbortSignal) => {
    try {
      if (user_id) {
        const browserData = await functionCollectBrowserData();
        const response = await auth.acceptRegistration(JSON.stringify(browserData) || '', user_id, link_id, room_id, signal);
        
        saveTokensAfterAuthentication(response.data); 
        localStorage.setItem('isFirstLogin', 'true');
        navigate('/');
        messageApi?.success(t('confirm.success'));
      }
    } catch (err) {
      resetTokensAndSendToLogin();
      messageApi?.error(t('confirm.error'));
    }
  };

  return <div></div>;
};

export default Confirm;
